import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Item = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 20px;
  height: 74px;
  padding: 15px 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  justify-content: space-between;
  gap: 10px;
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const ServiceName = styled(Typography.Body)<{ $isRefund: boolean }>`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme, $isRefund }) =>
    $isRefund ? theme.palette.system.green : theme.palette.primary.labels};
`;

export const Amount = styled(Typography.Body).attrs({ as: 'span' })<{
  $isIncome: boolean;
}>`
  flex-shrink: 0;
  font-weight: 500;
  color: ${({ theme, $isIncome }) =>
    $isIncome ? theme.palette.system.green : theme.palette.primary.labels};
`;

export const Meta = styled(Typography.Body)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Chevron = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  align-items: center;
  color: ${({ theme }) => theme.palette.primary.labels};
`;
